import { render, staticRenderFns } from "./ExerciseCreator.vue?vue&type=template&id=6bb23292&scoped=true"
import script from "./ExerciseCreator.vue?vue&type=script&lang=js"
export * from "./ExerciseCreator.vue?vue&type=script&lang=js"
import style0 from "./ExerciseCreator.vue?vue&type=style&index=0&id=6bb23292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb23292",
  null
  
)

export default component.exports